import FontToggle from './FontToggle'
import ColorToggle from './ColorToggle'

const ContactField = (props) => {
    const updateValue = (e) => {
        props.update(props.index, e.target.value, null)
    }

    const updateLabel = (e) => {
        props.update(props.index, null, e.target.value)
    }

    const updateColor = (color) => {
        props.update(props.index, null, null, color)
    }

    const updateFont = (font) => {
        props.update(props.index, null, null, null, font)
    }

    const updateUrl = (e) => {
        props.update(props.index, null, null, null, null, e.target.value)
    }

    const remove = () => {
        props.remove(props.index)
    }

    return (
        <div className="contactField is-flex is-justify-content-space-between is-align-items-flex-end">
            <div className="field">
                <label className="label">Label</label>
                <div className="control">
                    <input
                        className="input"
                        value={props.value.label}
                        onChange={updateLabel}
                    />
                </div>
            </div>
            <div className="field">
                <label className="label">Value</label>
                <div className="control">
                    <input
                        className="input"
                        value={props.value.value}
                        onChange={updateValue}
                    />
                </div>
            </div>
            <div className="field">
                <label className="label">Url</label>
                <div className="control">
                    <input
                        placeholder="URL: https://example.com"
                        className="input"
                        value={props.value.url}
                        onChange={updateUrl}
                    />
                </div>
            </div>
            <div className="field is-hidden">
                <label className="label">Color</label>
                <div className="control">
                    <ColorToggle
                        index={props.index}
                        update={updateColor}
                        value={props.value.color}
                    />
                </div>
            </div>
            <div className="field is-hidden">
                <label className="label">Font</label>
                <div className="control">
                    <FontToggle
                        index={props.index}
                        update={updateFont}
                        value={props.value.font}
                    />
                </div>
            </div>
            <button className="button is-danger mb-3" onClick={remove}>
                -
            </button>
        </div>
    )
}

export default ContactField
